<script>
import Menu from '/src/components/header.vue';
import Rodape from '/src/components/rodape.vue';

export default {
    name: 'Equipamentos',
    components: {
        Menu,
        Rodape,
    },
    data() {
        return {
            showModal: false, // Estado para controlar a visibilidade do modal
            selectedImage: '', // Caminho da imagem selecionada
        };
    },
    methods: {
        openModal(imageSrc) {
            this.selectedImage = imageSrc; // Define o caminho da imagem diretamente
            this.showModal = true; // Exibe o modal
        },
        closeModal() {
            this.showModal = false; // Oculta o modal
            this.selectedImage = ''; // Limpa a imagem selecionada
        },
    },
};
</script>

<template>
    <Menu></Menu>
    <div class="clientes">

        <p class="titulo">EQUIPAMENTOS</p>
        <p class="text">Usinagem</p>

        <div class="card">

            <div class="bloco2">
                <ul>
                    <li>Equipamento CNC:</li>
                    <li>Centro de Usinagem – X: 2000, Y: 1200, Z: 900</li>
                    <li>Centro de Usinagem – X: 1200, Y: 850, Z: 700</li>
                    <li>Centro de Usinagem – X: 1000, Y: 700, Z: 550</li>
                    <li>Torno CNC – Diâmetro: 850, Comprimento: 2000</li>
                    <li>Eletroerosão por penetração</li>
                    <li>Equipamento Convencional:</li>
                    <li>Torno Convencional – Diâmetro: 850, Comprimento: 3000</li>
                    <li>Torno Convencional – Diâmetro: 850, Comprimento: 2500</li>
                    <li>Torno Convencional – Diâmetro: 750, Comprimento: 2500</li>
                    <li>Torno Mascote – Diâmetro: 420, Comprimento: 1000</li>
                    <li>Fresas Ferramenteiras</li>
                    <li>Retífica Plana</li>
                    <li>Furadeira Radial</li>
                    <li>Plaina Limadora</li>
                </ul>
            </div>


            <div class="imagens">
                <div class="bloco1">
                    <img class="imagem" src="@/assets/usinagem/image6.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image6.jpeg'))">
                    <img class="imagem" src="@/assets/usinagem/image8.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image8.jpeg'))">
                    <img class="imagem" src="@/assets/usinagem/image2.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image2.jpeg'))">
                </div>

                <div class="bloco1">
                    <img class="imagem" src="@/assets/usinagem/image3.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image3.jpeg'))">
                    <img class="imagem" src="@/assets/usinagem/image7.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image7.jpeg'))">
                    <img class="imagem" src="@/assets/usinagem/image1.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image1.jpeg'))">
                    <img class="imagem" src="@/assets/usinagem/image10.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image10.jpeg'))">
                </div>
                <div class="bloco1">
                    <img class="imagem" src="@/assets/usinagem/image4.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image4.jpeg'))">
                    <img class="imagem" src="@/assets/usinagem/image5.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image5.jpeg'))">
                    <img class="imagem" src="@/assets/usinagem/image9.jpeg" alt=""
                        @click="openModal(require('@/assets/usinagem/image9.jpeg'))">
                </div>
                <div class="bloco1">

                </div>
            </div>
        </div>

        <!-- Modal -->
        <div v-if="showModal" class="modal" @click="closeModal">
            <div class="modal-content" @click.stop>
                <img :src="selectedImage" class="modal-image">
            </div>
        </div>
    </div>
    <Rodape></Rodape>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
    .clientes {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #ffffff;
        width: 100vw;
        padding: 02rem;
        min-height: 53.5vh;
    }

    .titulo {
        margin: 2rem;
        font-weight: bold;
        color: #2e74c4;
        font-size: 1.2rem;
    }

    .card {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .bloco1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }

    .bloco2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }

    .titulo {
        font-size: 1.2rem;
        font-weight: bold;
        margin: 1rem 0rem;
        color: #2e74c4;
        text-align: center;
    }

    .text {
        text-align: center;
        font-size: 1rem;
        color: #444;
        font-weight: bold;
    }

    .imagens {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin-top: 2rem;
    }

    .imagem {
        width: 100px;
        height: 100px;
        border-radius: 3px;
        cursor: pointer;
        object-fit: cover;
    }

    ul {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        width: 100%;
    }

    li {
        text-align: left;
        color: #444;
        line-height: 1.5rem;
        font-size: 0.8rem;
    }

    .modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ffffffc5;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }

    .modal-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        max-width: 550px;
        object-fit: cover;
    }

    .modal-image {
        width: 100%;
        height: auto;
        border-radius: 3px;
    }
}

@media (min-width: 901px) {
    .clientes {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #ffffff;
        width: 100vw;
        padding: 02rem;
        min-height: 53.5vh;
    }

    .card {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin: 1rem 0rem;
    }

    .bloco1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
    }

    .bloco2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        margin-right: 5rem;
    }

    .imagens {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    .titulo {
        font-size: 1.2rem;
        font-weight: bold;
        margin: 1rem 0rem;
        color: #2e74c4;
        text-align: center;
    }

    .text {
        text-align: center;
        font-size: 1rem;
        color: #444;
        font-weight: bold;
    }

    ul {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        width: 100%;
    }

    li {
        text-align: left;
        color: #444;
        line-height: 1.5rem;
    }

    .imagem {
        width: 120px;
        height: 120px;
        border-radius: 3px;
        cursor: pointer;
        object-fit: cover;
    }

    .modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000000e7;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }

    .modal-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        max-width: 550px;
        object-fit: cover;
    }

    .modal-image {
        width: 100%;
        height: auto;
        border-radius: 3px;
    }
}
</style>
